module.exports = __webpack_public_path__ + "static/Max-Harari-Invent-c1922d9acad99a4ae8949cf188875599.webp";